import { CLIENT_TITLE, IS_LOGGED, TOURNAMENT_ID, USER_DATA, USER_ID, USER_SYSTEM_ROLE } from "./localstorage_variables";

export const saveData = async(key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error saving data:", error);
  }
};

export const getData = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (error) {
    console.error("Error saving data:", error);
  }
};

export const removeData = async () => {
  try {
    localStorage.removeItem(IS_LOGGED);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(TOURNAMENT_ID);
    localStorage.removeItem(CLIENT_TITLE);
    localStorage.removeItem(USER_SYSTEM_ROLE);
  } catch (error) {
    console.error("Error retrieving data:", error);
  }
};
